import React from "react";
import { FormattedMessage } from "react-intl";

const Header = props => (
  <header className="text-center text-lg mb-4 font-medium">
    <>
      <div className="text-center">
        <img
          className="inline"
          style={{ width: 300 }}
          src={require("./assets/logo.png")}
        />
      </div>
    </>
  </header>
);

export default Header;
